module.exports = __webpack_public_path__ + "img/Skorpion.1ad853a0.png";